import React, {useRef, useMemo} from 'react'
import {
    DropDownNew
} from '@Knowledge-OTP/znk-ui-components'
import InnerFilter from './inner'
import FilterBadge from '../../../../common/FilterBadge'

const FilterDate = (props) => {
    const {filters = [], setFilters = () => {}, useInner = false} = props
    const badgeRef = useRef(null)
    const filterProps = useMemo(() => (
        {
            onCancel: () => {
                if(badgeRef?.current) badgeRef.current.click()
            },
            onApply: (newDates = []) => {
                setFilters(newDates)
                if(badgeRef?.current) badgeRef.current.click()
            },
            filters: filters
        }
    ), [badgeRef, filters, setFilters])
    
    return (
        useInner ? 
        <InnerFilter style={{maxWidth: 'auto'}} {...filterProps} /> : 
        <DropDownNew
            direction={'bottomCenter'}
            hoverEnabled={false}
            isOpen={false}
            options={
                [
                    {component: <InnerFilter {...filterProps}/>}
                ]
            }
            trigger={['click']}
        >
            <div
                onMouseEnter={() => {
                    badgeRef.current.click()
                }}
                className={`m-0 p-0`} 
                ref={badgeRef}
            >
                <FilterBadge
                    title='Date'
                    isActive={filters.some(Boolean)}
                    onClearFilters={() => setFilters([])}
                />
            </div>
        </DropDownNew>

    )
}

export default FilterDate
